import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Text } from 'elements';
import EditorComponent from 'components/base/EditorComponent';
import { showAlert } from 'components/modal/showConfirm';
import { saveMenteeAnswer } from 'libs/api/case';
import { trim } from 'libs/utils';
import { TCaseExplainDetail } from 'modules/case/types';
import { CDefaultEditorHeight, CWindowWidth } from 'constants/base.const';
import { Button, Input } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Colors } from 'GlobalStyles';

type TParams = {
  id: string;
  detail?: TCaseExplainDetail;
};

const Write = ({ id, detail }: TParams) => {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [question1, setQuestion1] = useState('');
  const [question2, setQuestion2] = useState('');
  const [question3, setQuestion3] = useState('');

  const checkForm = () => {
    const trimedQuestion1 = trim(question1);
    const trimedQuestion2 = trim(question2);
    const trimedQuestion3 = trim(question3);
    if (!trimedQuestion1 && !trimedQuestion2 && !trimedQuestion3) {
      showAlert(undefined, '해설 쓰기', 'Key Questions를 1개 이상 입력해주세요.');
      return false;
    }
    const trimedTitle = trim(title);
    if (!trimedTitle) {
      showAlert(undefined, '해설 쓰기', '제목을 입력해주세요.');
      return false;
    }
    const trimedContent = trim(content);
    if (!trimedContent) {
      showAlert(undefined, '해설 쓰기', '해설을 입력해주세요.');
      return false;
    }

    const questions = [];
    if (trimedQuestion1) questions.push(trimedQuestion1);
    if (trimedQuestion2) questions.push(trimedQuestion2);
    if (trimedQuestion3) questions.push(trimedQuestion3);
    return {
      key_questions: questions,
      title: trimedTitle,
      content: trimedContent,
      // thumbnail_id: 1,
      // file_ids: files
    };
  };

  const save = async () => {
    const params = checkForm();
    if (params) {
      const { success } = await saveMenteeAnswer(detail ? detail.id : id, params, !!detail);
      if (success) history.replace(`/case/board/${id}`);
    }
  };

  useEffect(() => {
    if (detail) {
      setTitle(detail.title || '');
      setContent(detail.content || '');
      setQuestion1(detail.key_question[0] || '');
      setQuestion2(detail.key_question[1] || '');
      setQuestion3(detail.key_question[2] || '');
    } else {
      // setDefaultFiles([]);
    }
  }, [detail]);

  return (
    <Grid
      maxWidth={`${CWindowWidth}px`}
      padding='50px 50px'
      md={{ padding: '50px 20px' }}
      sm={{ padding: '16px' }}
    >
      <Grid
        gap='50px'
        align='center'
        justify='space-between'
        sm={{ justify: 'space-between', padding: '0 5px' }}
      >
        <Text size='2rem'>해설 쓰기</Text>
        <Button className='text' onClick={() => {}}>
          <Grid align='center' gap='8px'>
            <LeftOutlined style={{ fontSize: 20, color: Colors.grey4 }} />
            <Text size='1.5rem' color={Colors.grey4}>
              Case 로 돌아가기
            </Text>
          </Grid>
        </Button>
      </Grid>
      <Grid
        margin='30px 0 10px 0'
        border='1px solid #f0f0f0'
        backgroundColor='#f5f5f5'
        padding='40px 20px'
        minHeight={`${CDefaultEditorHeight}px`}
      >
        <Grid>
          <Text size='1.1rem'>Key Questions:</Text>
        </Grid>
        <Grid marginTop='5px'>
          <Grid isNoWrap gap='10px' align='center'>
            <Text>∙</Text>
            <Input
              size='large'
              placeholder='Key Questions를 등록해주세요.'
              value={question1}
              onChange={(e) => setQuestion1(e.target.value)}
            />
          </Grid>
          <Grid marginTop='5px' isNoWrap gap='10px' align='center'>
            <Text>∙</Text>
            <Input size='large' value={question2} onChange={(e) => setQuestion2(e.target.value)} />
          </Grid>
          <Grid marginTop='5px' isNoWrap gap='10px' align='center'>
            <Text>∙</Text>
            <Input size='large' value={question3} onChange={(e) => setQuestion3(e.target.value)} />
          </Grid>
        </Grid>
        <Grid marginTop='25px'>
          <Text size='1.1rem'>제목</Text>
        </Grid>
        <Grid marginTop='5px'>
          <Input
            size='large'
            placeholder='제목을 입력해주세요'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Grid>
        <Grid marginTop='10px'>
          <EditorComponent content={content} onChange={setContent} apiPath='/menteeanswer/image/' />
        </Grid>
      </Grid>
      <Grid justify='flex-end' marginTop='20px'>
        <Grid isInline gap='10px'>
          <Button size='large' onClick={() => history.go(-1)}>
            취소
          </Button>
          <Button type='primary' size='large' onClick={save}>
            {!!detail ? '수정' : '등록'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Write;
